import { useState } from "react";
import PageLayout from "components/layout/PageLayout";
import { useAcceptRequestMutation, useDeclineRequestMutation, useDeleteRequestMutation, useGetAbsenceReportsPaginatedQuery } from "./api/absenceReportApiSlice";
import AbsenceRequestsTable, { KEY_ABSENCEREQUEST_ACTION_ACCEPT, KEY_ABSENCEREQUEST_ACTION_DELETE, KEY_ABSENCEREQUEST_ACTION_DENY } from "./components/AbsenceRequestsTable";
import { useTranslation } from "react-i18next";

const AUTO_REFRESH_INTERVAL = 1000*60*10 // 10 mins 

const AbsenceManageRequests = () => {
    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [requestPage, setRequestPage] = useState(0)
    const {
        data: response,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetAbsenceReportsPaginatedQuery(requestPage, {
        pollingInterval: AUTO_REFRESH_INTERVAL,
    })
    
    const [acceptRequest, accepetingResult] = useAcceptRequestMutation()
    const [declineRequest, decliningResult] = useDeclineRequestMutation()
    const [deleteRequest, deletingResult] = useDeleteRequestMutation()

    const handleAccept = (id) => {
        console.log(`The absence request (${id}) will be ACCEPTED`);
        acceptRequest(id)
    }

    const handleDecline = (id) => {
        console.log(`The absence request (${id}) will be DECLINED`);
        declineRequest(id)
    }

    const handleDelete = (id) => {
        console.log(`The absence request (${id}) will be DELETED`);
        deleteRequest(id)
    }

    const changePage = (page) => {
        console.log("Requesting page" + page + "...")
        setRequestPage(page)
    }

    let content;
    if (isSuccess) {
        content = (
            <AbsenceRequestsTable
                items={response.content}
                onRequestAccepted={handleAccept}
                onRequestDenied={handleDecline}
                onRequestDeleted={handleDelete}
                availableActions={[
                    KEY_ABSENCEREQUEST_ACTION_ACCEPT,
                    KEY_ABSENCEREQUEST_ACTION_DENY,
                    KEY_ABSENCEREQUEST_ACTION_DELETE
                ]}
                onPageChange={(number) => changePage(number - 1)}
                itemsPerPage={response.pageable.pageSize}
                totalItems={response.totalElements}
                currentPage={requestPage + 1}
            />
        )
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }

    return <PageLayout
        pageTitle={t("absenceReport:menu.absence_archive")}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
        bodyContent={content}
    />
}

export default AbsenceManageRequests